import type { useSingleton } from "@tippyjs/react";
import { useSetAtom } from "jotai";
import { TimerIcon } from "@/icons";
import { headerActiveButtonAtom } from "@/interface/AppStore";
import { BottomBarItem } from "@/interface/BottomBar/BottomRightBar";
import { Tooltip } from "@/interface/ui/Tooltip";
import styles from "../RightBar.module.scss";

type TimerButtonProps = {
    singletoneTarget: ReturnType<typeof useSingleton>[1];
    className?: string;
    isTimerRunning: boolean;
    timerTime: string;
    isTimerActive: boolean;
};

export const TimerButton = ({
    singletoneTarget,
    className,
    timerTime,
    isTimerRunning,
    isTimerActive,
}: TimerButtonProps) => {
    const setActiveHeaderButton = useSetAtom(headerActiveButtonAtom);

    const click = () => {
        setActiveHeaderButton("timer");
    };

    return (
        <Tooltip singleton={singletoneTarget} content="Таймер">
            <BottomBarItem className={className} active={isTimerActive} onClick={click}>
                <TimerIcon />
                {isTimerRunning && <span className={styles.timerTime}>{timerTime}</span>}
            </BottomBarItem>
        </Tooltip>
    );
};
